export function FieldErrors({ errors }) {
    return (<>
        {errors?.map(error => (<p key={error} className="help is-danger">{error}</p>))}
    </>);
}
